<template>
  <div class="vg_wrapper">
    <add-header
        @submit="submit('msotForm')"
        @cancel="cancel">
    </add-header>
    <el-form ref="msotForm" :rules="rules" :model="msotForm" label-width="120px" size="mini">
      <el-row>
        <el-col :md="8">
          <el-form-item label="出库编号" prop="msot_no">
            <el-input v-model="msotForm.msot_no" maxlength="10"  show-word-limit placeholder="请填写出库编号">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="出库时间" prop="msot_time">
            <el-date-picker
              v-model="msotForm.msot_time"
              type="date"
              placeholder="选择出库时间">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vg_button">
        <el-button type="primary" plain size="small" @click="addRow(0)">导入物料待出库</el-button>
        <el-button type="primary" plain size="small" @click="addRow(1)">导入物料</el-button>
        <el-button type="danger" plain size="small" @click="delBank()">删除</el-button>
      </div>
      <el-row class="vd_mrt">
        <MsotAddEditIn @handleSelectionChange="handleSelect" :msotForm="msotForm"></MsotAddEditIn>
      </el-row>
      <el-dialog
          :title="title"
          :visible.sync="notice"
          width="70%">
        <MsotAddEditMpot @confirmIn="confirmIn" ref="MsotAddEditMpot"></MsotAddEditMpot>
      </el-dialog>
      <el-dialog
          :title="title"
          :visible.sync="notice1"
          width="70%">
        <MsotAddEditMtrl @confirmIn="confirmIn" ref="MsotAddEditMtrl"></MsotAddEditMtrl>
      </el-dialog>
      <el-row class="vg_mt_16 vd_bortop">
        <el-col>
          <inputUser :isCookie="true" ref="userData"></inputUser>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {get,post} from "@api/request";
import addHeader from "@/views/component/addHeader";
import inputUser from "@/views/component/inputUser";
import MsotAddEditMpot from "@/views/StockManagement/MsotManage/TabChild/Component/MsotAddEditMpot";
import MsotAddEditMtrl from "@/views/StockManagement/MsotManage/TabChild/Component/MsotAddEditMtrl";
import MsotAddEditIn from "@/views/StockManagement/MsotManage/TabChild/Component/TabPanel/MsotAddEditIn";
import {msotAPI} from "@api/modules/msot";
export default {
  name: "MsotAddMain",
  components: {
    addHeader,
    inputUser,
    MsotAddEditIn,
    MsotAddEditMpot,
    MsotAddEditMtrl,
  },
  data(){
    return{
      msotForm:{
        msot_no:'',
        msot_time:'',
        msot_mtrl_list:[],
        key:0,
      },
      rules:{
        msot_no:[
          { required: true, trigger: 'blur' , message: ' '},
        ],
        msot_time:[
          { required: true, trigger: 'blur' , message: ' '},
        ],
      },
      removeList:[],
      msotList:[],
      notice:false,
      title:'',
      notice1:false,
    }
  },
  created() {
  },
  methods:{
    //提交表单
    submit(formName){
      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.saveInfo()
          } else {
            console.log('error submit!');
            return false;
          }
        });
      }).catch(()=>{

      })
    },
    //保存
    saveInfo() {
      const staffForm =  this.$refs.userData.getData()
      let msotForm = {};
      msotForm = Object.assign(msotForm,this.msotForm,staffForm);
      msotForm.msot_time = (new Date(msotForm.msot_time)).getTime() / 1000;
      post(msotAPI.addMsot,msotForm)
          .then(res => {
            if(res.data.code === 0){
              this.$message({
                type:'success',
                message:'保存成功'
              })
              const permId = this.$route.query.perm_id
              this.jump(`/msot_edit?perm_id=${permId}&form_id=${res.data.data.form_id}`)
              this.resetForm('msotForm')
            }else if(res.data.code === 7){
              this.$message({
                type:'error',
                message:'单据编号重复'
              })
              this.msotForm.msot_date = (new Date(this.msotForm.msot_date)).getTime() * 1000;
            } else {
              let mg = res.data.msg;
              let tp = 'error';
              this.$message({message: mg, type: tp});
              this.msotForm.msot_date = (new Date(this.msotForm.msot_date)).getTime() * 1000;
            }
          }).catch((res) =>{
            let msg = res.data.msg 
            this.$message.error(msg)
          })
    },
    //取消
    cancel(){
      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(() => {
        this.resetForm('msotForm')
        this.$router.go(-1)
        this.$message({
          type: 'info',
          message: '已取消新增!'
        })
      }).catch(()=>{

        });
    },
    //删除选择的内容
    handleSelect(val){
      this.removeList = val;
    },
    // 删除物料信息按钮
    delBank(){
      for(let i=0;i<this.removeList.length;i++){
        if(this.msotForm.msot_mtrl_list.indexOf(this.removeList[i]) !== -1){
          let index = this.msotForm.msot_mtrl_list.indexOf(this.removeList[i]);
          this.msotForm.msot_mtrl_list.splice(index,1)
        }
      }
    },
    // 打开导入物料信息小窗口
    addRow(num){
      if(num === 0){
        this.notice = true;
      }else if(num === 1){
        this.notice1 = true;
      }
    },
    // 导入小窗口确定按钮
    confirmIn(val){
      this.notice = false;
      this.notice1 = false;
      if(val.length>0){
        this.msotList = val;
        let msotListCopy = [];
        for(let i=0;i<this.msotList.length;i++){
          let temp = {};
          if(this.msotList[i].mpot_id){
            temp.mpot_id = this.msotList[i].mpot_id;
            temp.stay_mpot_num = parseInt(this.msotList[i].mtrl_num)-parseInt(this.msotList[i].mpot_num);
          }
          temp.mtrl_id = this.msotList[i].mtrl_id;
          temp.mtrl_no = this.msotList[i].mtrl_no;
          temp.mtrl_name = this.msotList[i].mtrl_name;
          temp.mtrl_unit = this.msotList[i].mtrl_unit;
          msotListCopy.push(temp)
        }
        this.msotForm.msot_mtrl_list = this.msotForm.msot_mtrl_list.concat(msotListCopy);
        if(this.msotList[0].mpot_id){
          this.$refs.MsotAddEditMpot.clear()
        }else{
          this.$refs.MsotAddEditMtrl.clear()
        }
      }
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.msotForm.msot_mtrl_list = [];
    },
  }
}
</script>

<style scoped lang="scss">
.vd_mrt{
  margin-top: 20px;
}
.vd_bortop {
  border-top: #DCDFE6 solid 1px;
  padding-top: 20px;
}
</style>